// Identifiers
export const IDENTIFIER_SLUG_FONT_SIZE = 11;
export const IDENTIFIER_LINE_HEIGHT = 0.82;
export const IDENTIFIER_MAX_WIDTH = 200;
export const IDENTIFIER_SHRINK_MIN_WIDTH = 143;

export const RELATIONSHIP_VIEW_OVERSCROLL = 200;
export const TIMELINE_VIEW_OVERSCROLL = 800;
export const TIMELINE_HEADER_VIEW_OVERSCROLL = 400;
export const TIMELINE_CONTEXT_OVERSCROLL = 500;
export const OUTLINE_VIEW_OVERSCROLL = 200;
export const TABLE_VIEW_DEFAULT_OVERSCROLL = 0; //200;

export const SPLIT_DIVIDER_SIZE = 1;

// // Color Picker Popover
export const COLOR_PICKER_POPOVER_WIDTH = 150;

export const MAX_LAYOUT_CHILDREN_PER_SPLIT = 5;
export const MAX_LAYOUT_DEPTH = 3;

// Scroll View
export const SCROLL_RUBBER_BAND_MAX = 10;

// Note: This should match the height of the content
// of the header.
export const ITEM_CARD_LIST_HEADER_HEIGHT = 47;
export const ITEM_CARD_ARROW_SIZE = 10;

export const ITEM_CARD_ARROW_PADDING_TOP = 3;
export const ITEM_CARD_ARROW_PADDING_RIGHT = 8;
export const ITEM_CARD_ARROW_PADDING_BOTTOM = 5;
export const ITEM_CARD_ARROW_PADDING_LEFT = 10;

export const ITEM_CARD_IDENTIFIER_ROW_MARGIN_Y = 5;
export const ITEM_CARD_IDENTIFIER_MARGIN_X = 5;
export const ITEM_CARD_IDENTIFIER_MARGIN_Y = 1;
export const ITEM_CARD_MAX_INLINE_RELATED_IDENTIFIERS = 5;
export const ITEM_CARD_MAX_INLINE_IDENTIFIERS = 4;
export const ITEM_CARD_INLINE_AVATAR_SIZE = 22;
export const ITEM_CARD_INLINE_AVATAR_MARGIN_X = 5;
export const ITEM_CARD_INLINE_AVATAR_MARGIN_Y = 1;
export const ITEM_CARD_INLINE_IDENTIFIER_PADDING = 4;
export const ITEM_CARD_AVATAR_REMAINER_PADDING_X = 5;
export const ITEM_CARD_MARGIN_Y = 10;
export const ITEM_CARD_IMAGE_MARGIN_TOP = 10;
export const ITEM_CARD_IMAGE_WIDTH = 220;
export const ITEM_CARD_IMAGE_HEIGHT = 150;
export const ITEM_CARD_NARRATIVE_MARGIN_TOP = 5;
export const ITEM_CARD_BLOCK_ICON_SIZE = 15;
export const ITEM_CARD_EVENT_ROW_PADDING_LEFT = 8;
export const ITEM_CARD_EVENT_ROW_PADDING_RIGHT = 10;
export const ITEM_CARD_EVENT_ROW_EDIT_MODE_PADDING_X = 8;
export const ITEM_CARD_EVENT_COL_PADDING_LEFT = 0;
export const ITEM_CARD_INDENT_PADDING = 19;
export const ITEM_CARD_INDENT_PADDING_WIDTH_CHILDREN = 18;
export const ITEM_CARD_DRAG_HANDLE_PADDING_LEFT = 5;
export const ITEM_CARD_DRAG_HANDLE_PADDING_RIGHT = 10;
export const ITEM_CARD_DRAG_HANDLE_PADDING_TOP = 0;
export const ITEM_CARD_DRAG_HANDLE_PADDING_BOTTOM = 10;
export const ITEM_CARD_FORM_RADIO_PADDING_LEFT = 6;
export const ITEM_CARD_FORM_RADIO_PADDING_RIGHT = 2;

// export const ITEM_CARD_CONSTRAINT_WIDTH = 17;

// Timeline View
export const TIMELINE_AGE_LABEL_FONT_SIZE = 13;
export const TIMELINE_HEADER_HEIGHT = 63;
export const TIMELINE_MOBILE_HEADER_HEIGHT = 40;
export const TIMELINE_GROUP_HEADER_HEIGHT = 24;
export const TIMELINE_GROUP_TOP_PADDING = 10;
export const TIMELINE_AGE_VIEW_HEIGHT = 24;
export const CONTEXT_BAR_HEIGHT = 31;
export const CONTEXT_BAR_CONTENT_PADDING = 20;
export const TIMELINE_HEADER_MAJOR_TICK_SPACING = 200;
export const TIMELINE_CONTEXT_MAJOR_TICK_SPACING = 200;
export const TIMELINE_HEADER_AGE_TICK_SPACING = 125;
export const TIMELINE_HIDE_ITEM_CARD_MARKER_LABEL_MARGIN_LEFT = 6;

// Calendar Markers in Timeline View
export const MIN_CALENDAR_MARKER_PIXEL_SPACING = 125;
export const CALENDAR_MARKER_DOT_WIDTH = 6;
export const CALENDAR_MARKER_ICON_WIDTH = 15;
export const CALENDAR_MARKER_MIN_BAR_WIDTH = 50;

// Mindmap View
export const MINDMAP_IMPORT_SPACING = 20;
export const MINDMAP_BOUNDARY_MIN_PADDING = 100;

export const MINDMAP_NODE_MIN_WIDTH = 249;
export const MINDMAP_NODE_MIN_HEIGHT = 38;
export const MINDMAP_NODE_AVATAR_SIZE = 22;
export const MINDMAP_NODE_LEFT_SPACE_TO_ITEM_CARD = 37;
export const MINDMAP_NODE_RIGHT_SPACE_TO_ITEM_CARD = 23;
export const MINDMAP_NODE_PADDING_Y = 11;
export const MINDMAP_SUPER_BAR_HEIGHT = 7;
export const MINDMAP_SUPER_BAR_RADIUS = 3;

// Relationship View
export const RELATIONSHIP_HEADER_HEIGHT = 128;
export const EMPTY_RELATIONSHIP_HEADER_HEIGHT = 0.0001;
// Calculated from:
//   $relationshipEventExpandArrow + $relationshipEventTextWidth + ($itemCardEventDotXMargin * 2) + $itemCardEventDotSize + ($relationshipEventPadding * 2)
// Which is:
//   15 + 300 + 5 * 2 + 10 + 4 * 2 = 343
export const RELATIONSHIP_EVENT_COLUMN_WIDTH = 343;
export const RELATIONSHIP_EVENT_COLUMN_PADDING_Y = 10;
export const RELATIONSHIP_EVENT_COLUMN_PADDING_X = 4;

export const RELATIONSHIP_EVENT_EXPAND_CHILDREN_ARROW_WIDTH = 14;
export const RELATIONSHIP_EVENT_INDENT_PADDING = 26;

export const RELATIONSHIP_GROUP_LABEL_WIDTH = 144;
export const RELATIONSHIP_ENTITY_COLUMN_WIDTH = 51;
export const RELATIONSHIP_ROW_Y_PADDING = 10;
export const RELATIONSHIP_INTERSECTION_ICON_SIZE = 20;
export const RELATIONSHIP_INTERSECTION_AGE_SIZE = 10;

// Outline View
export const OUTLINE_CELL_ROW_GUTTER_WIDTH = 27;
export const OUTLINE_CELL_PADDING = 8;
export const OUTLINE_CELL_CHILD_ARROW_WIDTH = 10;

export const OUTLINE_CELL_CHILD_ARROW_PADDING_TOP = 8;
export const OUTLINE_CELL_CHILD_ARROW_PADDING_RIGHT = 0;
export const OUTLINE_CELL_CHILD_ARROW_PADDING_BOTTOM = 10;
export const OUTLINE_CELL_CHILD_ARROW_PADDING_LEFT = 6;

export const OUTLINE_CELL_CHILD_ARROW_MARGIN_TOP = 3;

export const OUTLINE_CELL_LABEL_ICON_SIZE = 16;
export const OUTLINE_CELL_MIN_HEIGHT = 16 + 2 * OUTLINE_CELL_PADDING;
export const OUTLINE_HEADER_HEIGHT = 21;
export const OUTLINE_LABEL_COLUMN_WIDTH = 343;
export const OUTLINE_LABEL_COLUMN_MIN_WIDTH = 200;
export const OUTLINE_MULTI_LINE_TEXT_COLUMN_MIN_WIDTH = 160;
export const OUTLINE_SEQUENCE_COLUMN_WIDTH = 54;
export const OUTLINE_NARRATIVE_COLUMN_WIDTH = 108;
export const OUTLINE_SUMMARY_COLUMN_WIDTH = 343;
export const OUTLINE_ID_COLUMN_WIDTH = 50;
export const OUTLINE_DEFAULT_COLUMN_WIDTH = 140;
export const OUTLINE_MIN_COLUMN_WIDTH = 20;
// If the container width - fixed column width < this min scrollable columns width
// then should convert the fixed columns to scrollable ones
export const OUTLINE_MIN_SCROLLABLE_COLUMNS_WIDTH = 150;

// Table View
export const TABLE_HEADER_HEIGHT = 21;
export const TABLE_DRAG_DROP_BORDER_SIZE = 8;
export const TABLE_CELL_ROW_GUTTER_WIDTH = 26;
export const TABLE_CELL_MAX_IDENTIFIERS = 4;
export const TABLE_CELL_IDENTIFIERS_MAX_LENGTH = 20;
export const TABLE_CELL_IDENTIFIERS_MAX_ROWS = 2;
export const TABLE_IDENTIFIER_SLUG_FONT_SIZE = 11;
export const TABLE_IDENTIFIER_SLUG_MIN_WIDTH = 40;
export const TABLE_IDENTIFIER_SLUG_MARGIN_X = 8;
export const TABLE_IDENTIFIER_SLUG_MARGIN_TOP = 6;
export const TABLE_IDENTIFIER_SLUG_MARGIN_BOTTOM = 3;
export const TABLE_CELL_AVATAR_WIDTH = 22;
export const TABLE_CELL_AVATAR_MARGIN_TOP = 4;
export const TABLE_CELL_AVATAR_MARGIN_RIGHT = 0;
export const TABLE_CELL_AVATAR_MARGIN_BOTTOM = 4;
export const TABLE_CELL_AVATAR_MARGIN_LEFT = 4;

export const TABLE_CELL_TEXT_AREA_PADDING_VERTICAL = 8;
export const TABLE_CELL_TEXT_AREA_PADDING_HORIZONTAL = 8;
export const TABLE_CELL_ICON_MARGIN_LEFT = 8;
export const TABLE_CELL_ICON_MARGIN_TOP = 8;

export const TABLE_CARD_INDENT_PADDING = 28;
export const TABLE_CARD_INDENT_PADDING_WITH_CHILDREN = 18;

// Subway View
export const SUBWAY_VIEW_THREAD_SETTINGS_HEIGHT = 45;
export const SUBWAY_VIEW_THREAD_LABEL_LEFT = 10;
export const SUBWAY_VIEW_THREAD_LABEL_WIDTH = 240;
export const SUBWAY_VIEW_THREAD_LABEL_MARGIN = 80;
export const SUBWAY_VIEW_THREAD_LABEL_HEIGHT = 40;
export const SUBWAY_VIEW_THREAD_THICKNESS = 5;
export const SUBWAY_VIEW_THREAD_SPLIT_WIDTH = SUBWAY_VIEW_THREAD_LABEL_LEFT + SUBWAY_VIEW_THREAD_LABEL_WIDTH;

export const SUBWAY_DOT_SIZE = 38;
export const SUBWAY_TEXT_PADDING = 5;
export const SUBWAY_CARD_TEXT_WIDTH = 168;
export const SUBWAY_CARD_WIDTH = 200;
export const SUBWAY_NO_TEXT_SPACING = 60;
export const SUBWAY_CARD_MIN_INNER_HEIGHT = 80;
export const SUBWAY_CARD_MARGIN = 10;
export const SUBWAY_HEADER_HEIGHT = 34;
export const SUBWAY_HEADER_PADDING_Y = 14;
export const SUBWAY_THREAD_MARGIN = 12;
export const SUBWAY_NODE_LEFT_SPACE_TO_ITEM_CARD = 37;
export const SUBWAY_NODE_RIGHT_SPACE_TO_ITEM_CARD = 23;
export const SUBWAY_CARD_X_PADDING = 11;
export const SUBWAY_CARD_Y_PADDING = 11;
export const SUBWAY_NODE_AVATAR_SIZE = 22;
export const SUBWAY_HEADER_TICK_FREQUENCY_NORMAL = 2;
export const SUBWAY_HEADER_TICK_FREQUENCY_NO_TEXT = 4;

// Identifiers List
export const IDENTIFIER_LIST_DOWN_ARROW_SIZE = 9;
export const IDENTIFIER_LIST_DOWN_ARROW_MARGIN_X = 4;
export const IDENTIFIER_LIST_DOWN_ARROW_PADDING_TOP = 8;

// Mobile
export const MOBILE_TOOLBAR_VIEW_SELECTOR_MAX_OPTIONS = 8;
export const MOBILE_VIEWS_SELECTOR_WIDTH_PADDING = 50;
export const MOBILE_TOOLBAR_RIGHT_GROUP_MIN_WIDTH = 160;

// Form
export const SPLIT_BUTTON_LINE_HEIGHT = 14;
export const SPLIT_BUTTON_LABEL_PADDING_Y = 10;

// Entity List
export const ENTITY_LIST_COLLAPSE_ARROW_PADDING_TOP = 3;
export const ENTITY_LIST_COLLAPSE_ARROW_PADDING_RIGHT = 8;
export const ENTITY_LIST_COLLAPSE_ARROW_PADDING_BOTTOM = 5;
export const ENTITY_LIST_COLLAPSE_ARROW_PADDING_LEFT = 10;
export const ENTITY_LIST_ICON_LARGE_SIZE = 20;
export const ENTITY_LIST_DRAG_HANDLE_PADDING_TOP = 0;
export const ENTITY_LIST_DRAG_HANDLE_PADDING_RIGHT = 10;
export const ENTITY_LIST_DRAG_HANDLE_PADDING_BOTTOM = 0;
export const ENTITY_LIST_DRAG_HANDLE_PADDING_LEFT = 5;
export const ENTITY_LIST_MEDIUM_DOT_SIZE = 12;
export const ENTITY_LIST_MEDIUM_DOT_PADDING_TOP = 3; // px
export const ENTITY_LIST_MEDIUM_DOT_PADDING_RIGHT = 2; // rem
export const ENTITY_LIST_MEDIUM_DOT_PADDING_BOTTOM = 0; // px
export const ENTITY_LIST_MEDIUM_DOT_PADDING_LEFT = 6.5; // rem

// Tree View
export const TREE_VIEW_ITEM_BASE_PADDING_LEFT = 8;
export const TREE_VIEW_COLLAPSE_ARROW_SIZE = 10;
export const TREE_VIEW_COLLAPSE_ARROW_PADDING_TOP = 6;
export const TREE_VIEW_COLLAPSE_ARROW_PADDING_RIGHT = 4;
export const TREE_VIEW_COLLAPSE_ARROW_PADDING_BOTTOM = 0;
export const TREE_VIEW_COLLAPSE_ARROW_PADDING_LEFT = 4;
export const TREE_VIEW_LIST_ITEM_MIDDLE_ELEMENT_MARGIN_LEFT = 4.5;
export const TREE_VIEW_INDENT =
  ENTITY_LIST_ICON_LARGE_SIZE + TREE_VIEW_LIST_ITEM_MIDDLE_ELEMENT_MARGIN_LEFT - TREE_VIEW_COLLAPSE_ARROW_PADDING_LEFT;

// Scale a value by the changed font size
// const BASE_FONT_SIZE = 13;
// export const scalePixelsToFontSize = (p, fontSize) => (p * fontSize) / BASE_FONT_SIZE;
